import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';

@Component({
    selector: 'app-info-guide',
    templateUrl: './info-guide.component.html',
    styleUrls: ['./info-guide.component.scss'],
    standalone: false
})
export class InfoGuideComponent implements OnInit {

  constructor(public modalRef: BsModalRef) { }

  ngOnInit(): void {
  }

}
